export const ES_AR = 'es-AR';
export const ES_MX = 'es-MX';
export const PT_BR = 'pt-BR';
export const ES_CO = 'es-CO';

export const getConfig = () => ({
  locale: process.env.NEXT_PUBLIC_WWW_LOCALE,
  gtmID: process.env.NEXT_PUBLIC_WWW_GTM_ID,
  mailchimpListId: process.env.NEXT_PUBLIC_WWW_MAILCHIMP_LIST_ID,
  mailchimpWaitListId: process.env.NEXT_PUBLIC_WWW_MAILCHIMP_WAITLIST_ID,
  domain: process.env.NEXT_PUBLIC_WWW_DOMAIN,
  discoveryUrlEncodedStaging: process.env.NEXT_PUBLIC_WWW_DISCOVERY_URL_ENCODED_STAGING,
  discoveryUrlEncodedProd: process.env.NEXT_PUBLIC_WWW_DISCOVERY_URL_ENCODED_PROD,
  inviterUrlEncodedStaging: process.env.NEXT_PUBLIC_WWW_INVITER_URL_ENCODED_STAGING,
  inviterUrlEncodedProd: process.env.NEXT_PUBLIC_WWW_INVITER_URL_ENCODED_PROD,
  backendUrlEncodedStaging: process.env.NEXT_PUBLIC_WWW_BACKEND_URL_ENCODED_STAGING,
  backendUrlEncodedProd: process.env.NEXT_PUBLIC_WWW_BACKEND_URL_ENCODED_PROD,
});

export const domainByLocale = locale => ({
  [ES_AR]: 'https://nu.com.ar',
  [ES_MX]: 'https://nu.com.mx',
  [PT_BR]: 'https://nubank.com.br',
  [ES_CO]: 'https://nu.com.co',
}[locale]);
